import { render, staticRenderFns } from "./BodyType.vue?vue&type=template&id=79725559&scoped=true"
import script from "./BodyType.vue?vue&type=script&lang=js"
export * from "./BodyType.vue?vue&type=script&lang=js"
import style0 from "./BodyType.vue?vue&type=style&index=0&id=79725559&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79725559",
  null
  
)

export default component.exports